import React from 'react';
import { CheckIcon, FileTextIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
export function Bonuses() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-42" data-mp="au1vkqui6mkh">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="fu6cuj38jlbr">
        <Eyebrow data-id="element-44" data-mp="ft4q3hcuxae7">
          <span className="inline-flex items-center gap-2" data-id="element-45" data-mp="fsljgwsnq8fh">
            <GiftIcon className="h-4 w-4" data-id="element-46" data-mp="1tvk1aid7wny" /> Y además recibís
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-47" data-mp="5wi4gqcpifb4">
          🎁 5 bonos completos <span className="text-sky-600" data-id="element-48" data-mp="5xjrzuawsu9q">sin costo adicional</span>
        </SectionTitle>
        <SectionLead data-id="element-49" data-mp="3o2wqzdp1jxl4">
          Además de los 5 tomos principales, hoy también te llevás 5 bonos. Son otros{' '}
          <b className="text-slate-900" data-id="element-50" data-mp="3t0ycs6duqb0a">25 proyectos completos</b> para ampliar el sistema a
          mascotas, escritorio, espacios pequeños, mate, café y organización de herramientas.
        </SectionLead>

        <div className="mt-8 space-y-4" data-id="element-51" data-mp="1r78t1d1fa8ve">
          {bonuses.map(bonus => <article key={bonus.number} className={`grid gap-4 rounded-2xl border bg-white p-5 shadow-sm md:grid-cols-[1fr_1.2fr] md:gap-8 md:p-6 ${bonus.featured ? 'border-2 border-sky-600' : 'border-slate-200'}`} data-id="element-52" data-mp="3icvcze8b2o2z">
              <div className="flex flex-col" data-id="element-53" data-mp="3n4mukz9hhjgz">
                <div className="flex gap-3" data-id="element-54" data-mp="3n5ofrwk7rmcf">
                  <span className="text-3xl leading-none" data-id="element-55" data-mp="2zfaldze5pbeo">{bonus.icon}</span>
                  <div data-id="element-56" data-mp="2zhf07cdlfutq">
                    <small className="font-extrabold uppercase tracking-wide text-sky-700" data-id="element-57" data-mp="2uh0rrt82yiv6">
                      Bono {bonus.number}
                    </small>
                    <h3 className="text-lg font-black uppercase leading-tight text-slate-900" data-id="element-58" data-mp="38e5sresxsrjk">
                      {bonus.name}
                    </h3>
                  </div>
                </div>
                <p className="mt-3 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-59" data-mp="ns4bqd4poebe">
                  {bonus.description}
                </p>
                <div className="mt-auto flex flex-wrap items-center gap-3 pt-4 text-sm font-extrabold" data-id="element-60" data-mp="3cjpqj5ln96r9">
                  <span className="flex items-center gap-1.5 text-xs font-bold text-slate-500" data-id="element-61" data-mp="3hh7yasnxdfxo">
                    <FileTextIcon className="h-3.5 w-3.5" data-id="element-62" data-mp="3ljcthvu0ukmf" /> 40 páginas
                  </span>
                  <span className="text-slate-400 line-through" data-id="element-63" data-mp="3qixra2xggmxk">{bonus.value} ARS</span>
                  <span className="rounded-full bg-sky-600 px-3 py-1 text-white" data-id="element-64" data-mp="2tsyl2f4s20i5">🎁 HOY GRATIS</span>
                </div>
              </div>
              <ul className="space-y-1.5 border-t border-slate-200 pt-4 text-sm font-semibold leading-snug text-slate-600 md:border-l md:border-t-0 md:pl-8 md:pt-0" data-id="element-65" data-mp="2xujrpiqpxijw">
                {bonus.items.map(item => <li key={item} className="flex gap-2" data-id="element-66" data-mp="37l4rh9i4ot4e">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" data-id="element-67" data-mp="2a57l8qmrzola" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}